export default function getCustomerTokenHeaderObject(
  token: string | null | undefined,
) {
  if (!token) {
    return {}
  }

  return {
    headers: {
      customerToken: token,
    },
  }
}
